import React from 'react';
import moment from 'moment-timezone';

const RefundOverlay = ({ booking }) => {
  if (!booking || !booking.cancelledAt) { return null; }
  let refundDetails;
  if (moment().diff(booking.cancelledAt, 'days') < 7 ) {
    refundDetails = <div className='refund-details'>Allow up to 5 days to process</div>;
  }

  return (
    <div className='refund-overlay'>
      <div className='refund-inner'>
        <div className="refund-title">**REFUNDED**</div>
        {refundDetails}
      </div>
    </div>
  );
};

export default RefundOverlay;
